import * as React from 'react';
import { TableBody } from './TableBody';
import { TableHead } from './TableHead';
import { TableRow } from './TableRow';
import { TableCell } from './TableCell';
import { TableHeadCell } from './TableHeadCell';
import { TableHeadRow } from './TableHeadRow';
import { TableFoot } from './TableFoot';
export const Table = ({ as = 'table', ...rest }) => {
    return React.createElement(as, {
        role: as !== 'table' ? 'table' : undefined,
        ...rest,
    });
};
Table.Body = TableBody;
Table.Head = TableHead;
Table.HeadRow = TableHeadRow;
Table.HeadCell = TableHeadCell;
Table.Row = TableRow;
Table.Cell = TableCell;
Table.Foot = TableFoot;
